import script from "./EditBlogModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditBlogModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditBlogModal.vue?vue&type=style&index=0&id=7fe373f4&lang=css"

const __exports__ = script;

export default __exports__